import { mutatorAction } from 'satcheljs';
import { ExtendedPalette } from '../store/schema/ExtendedTheme';
import store from '../store/store';

export default mutatorAction(
    'MUTATE_FABRIC_THEME',
    (themeSymbols: Partial<ExtendedPalette>, isDarkTheme: boolean) => {
        store().palette = themeSymbols;
        store().isInverted = isDarkTheme;
    }
);
